'use client'

import type { PropsWithChildren, ReactNode, Ref } from 'react'
import { RadioGroup as HeadlessRadioGroup } from '@headlessui/react'

import { cn } from '@mntn-dev/ui-utilities'

import { getTestProps, type TestIds } from '../../utils/testing.ts'
import { RadioBlock } from './radio-block.tsx'
import { RadioButton } from './radio-button.tsx'

type RadioGroupProps = Readonly<
  PropsWithChildren<
    TestIds & {
      children: Array<ReactNode>
      className?: string
      disabled?: boolean
      label: string
      onChange: (value: string) => void
      ref?: Ref<HTMLDivElement>
      value?: string
    }
  >
>

const RadioGroup = ({
  children,
  className,
  dataTestId,
  dataTrackingId,
  disabled,
  label,
  onChange,
  ref,
  value,
}: RadioGroupProps) => {
  return (
    <HeadlessRadioGroup
      ref={ref}
      className={cn('group flex flex-row gap-4', className)}
      disabled={disabled}
      value={value}
      onChange={onChange}
      aria-label={label}
      data-selected-value={value}
      {...getTestProps({ dataTestId, dataTrackingId })}
    >
      {children}
    </HeadlessRadioGroup>
  )
}

const RadioNamespace = Object.assign(RadioGroup, {
  Item: RadioBlock,
  Button: RadioButton,
})

export { type RadioGroupProps, RadioNamespace as RadioGroup }
